import { Link } from 'react-router-dom';
import Btns from '../../components/btns/Btns'
import './department.css'
import { useContext, useEffect, useState } from 'react';
import kafedrImg from '../../image/kafedr.png'
import axios from 'axios';
import AppContext from '../../context/AppContext';
import Footer from '../../components/footer/Footer';


export default function Department() {

    // btn set
    const [activeButton, setActiveButton] = useState(2);

    const buttons = [
        {
            id: 1,
            name_uz: 'Universitet haqida',
            name_ru: 'Об Университете',
            name_en: 'About University',
            link: '/about',
        },
        {
            id: 2,
            name_uz: 'Kafedralar',
            name_ru: 'Факультеты',
            name_en: 'Faculties',
            link: '/department',
        },
        {
            id: 3,
            name_uz: 'Markaz va boʻlimlar',
            name_ru: 'Центры и Отделы',
            name_en: 'Centers and other departments',
            link: '/departments',
        },
        {
            id: 4,
            name_uz: 'Rektorat',
            name_ru: 'Ректорат',
            name_en: 'University Rectorate',
            link: '/rektorat',
        },
        {
            id: 5,
            name_uz: 'Universitet ichki mehnat tartib qoidalar',
            name_ru: 'Кодекс внутреннего трудового порядка университета',
            name_en: 'BEHAVIORAL CODE',
            link: '/rules',
        },
        {
            id: 6,
            name_uz: 'Universitet odob-axloq qoidalari',
            name_ru: 'Кодекс поведения',
            name_en: 'BEHAVIORAL CODE',
            link: '/rulesEtika',
        },
        {
            id: 7,
            name_uz: 'Universitet nizomi',
            name_ru: 'Устав Университета',
            name_en: 'University charter',
            link: '/regulation',
        },
        {
            id: 8,
            name_uz: "Universitet tashkiliy tuzilmasi",
            name_ru: "Cтруктура Университета",
            name_en: "Structure of the University",
            link: "/tashkiliytuzilmasi"
        }
    ]

    const [data, setData] = useState([])

    const getData = async () => {
        const response = await axios.get(`https://new.utu-ranch.uz/category/kafedrashu/`)
        setData(response.data)
    }

    useEffect(() => {
        getData()
    }, [])

    const { leng } = useContext(AppContext);

    return (
        <>
            <div className="department">
                <Btns activeButton={activeButton} setActiveButton={setActiveButton} buttons={buttons} />
                {
                    data.map(item => (
                        <div className="department_box">
                            <div className="department_box_img">
                                <img src={item.image} alt="" />
                            </div>
                            <div className="department_box_menu">
                                <Link to={`/department/${item.id}`}><p className="department_box_menu_title">{item[`name_${leng}`]}</p></Link>
                                <ul>
                                    {
                                        item.children_kafedra.map(info => (
                                            <Link to={`/department/${info.id}`}><li>{info[`name_${leng}`]}</li></Link>
                                        ))
                                    }
                                </ul>
                            </div>
                        </div>
                    ))
                }
            </div>
            <Footer />
        </>
    )
}